module.exports = __webpack_public_path__ + "img/factura.309e0241.png";